import { render, staticRenderFns } from "./GuiaFatura.vue?vue&type=template&id=ddad4716&"
import script from "./GuiaFatura.vue?vue&type=script&lang=js&"
export * from "./GuiaFatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports